import { FormDefinition, ProgramConfig } from '../../../types/apiModels'
import { getFormDefinition } from './getFormDefinition'

export default async function getDataCollectionFormDefinitions({
  programConfig,
  signal,
}: {
  programConfig: ProgramConfig
  signal?: AbortSignal
}): Promise<FormDefinition[] | null> {
  if (!programConfig?.formDefinitions?.dataCollection) return null
  return Promise.all(
    programConfig.formDefinitions.dataCollection.map(formDefinition =>
      getFormDefinition({ id: formDefinition.id, signal }),
    ),
  )
}
